import { fireArtifactAction } from "@/components/artifacts/ArtifactActionsButtons.tsx";
import { errorToast } from "@/components/ui/toast.tsx";
import type { ArtifactAction } from "@/types/artifacts.ts";
import * as Sentry from "@sentry/react";

/**
 * Resolve a picker card through its own Done action, the one its button fires,
 * so the card closes and the agent hears about it the same way. A card with no
 * Done (cancelled, or superseded) is left alone. A failed Done is reported and
 * toasted, as the button's own failure is: the join it follows has already
 * gone through, so only the card is left open.
 */
export async function firePickerDone(actions: ArtifactAction[] | undefined): Promise<void> {
  const done = actions?.find((action) => action.id === "done");
  if (!done) return;
  try {
    await fireArtifactAction(done);
  } catch (error) {
    Sentry.captureException(error);
    errorToast("Couldn't close the card. Press Done to finish.");
  }
}
